import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate, Link } from "react-router-dom";
import { LeadSource } from '../../utils/enums'

const LeadsGlobalSearch = ({ globalSearchValue }) => {
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [sortModel, setSortModel] = useState([]);
    const navigate = useNavigate();
    const { post } = useApiManager();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 50,
    });

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5 },
        {
            field: 'firstName',
            headerName: 'First Name',
            flex: 1,
            renderCell: (params) => {
                const displayName = params.value?.trim() || "(N/A)"; // fallback if null, undefined, or empty
                return (
                    <Link
                        to={`/leads/${params.row.id}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{ color: 'inherit' }}
                    >
                        {displayName}
                    </Link>
                );
            },
        },
        { field: 'lastName', headerName: 'Last Name', flex: 1 },
        { field: 'company', headerName: 'Company', flex: 1 },
        { field: 'email', headerName: 'Email', flex: 1 },
        { field: 'phone', headerName: 'Phone', flex: 0.8 },
        { field: 'leadSource', headerName: 'Lead Source', flex: 0.8 },
        { field: 'ownerName', headerName: 'Lead Owner', flex: 0.8 },
    ];

    const transformData = (data) => {
        return data.map(item => ({
            id: item.id,
            firstName: item.firstName,
            lastName: item.lastName,
            company: item.company,
            email: item.email,
            phone: item.phone,
            leadSource: LeadSource?.[item.leadSource]?.label || '',
            ownerName: item.ownerName
        }));
    };

    useEffect(() => {
        const fetchAndSetData = async () => {
            setLoading(true);
            try {
                const operatorMapping = {
                    "contains": 2,
                    "equals": 0,
                    "starts with": 4,
                    "ends with": 5,
                    "is empty": 6,
                    "is not empty": 7,
                    // "is any of": Not directly mapped
                };



                const sortField = sortModel.length > 0 ? sortModel[0].field : 'createdAt'; // Default to 'firstName'
                const sortDescending = sortModel.length > 0 ? sortModel[0].sort === 'desc' : false;

                let url = "/leads/paged/globalsearch";

                const data = await post(url, {
                    pageNumber: paginationModel.page + 1,
                    pageSize: paginationModel.pageSize,
                    sortField: sortField,
                    sortDescending: sortDescending,
                    globalSearchValue: globalSearchValue
                });
                setRows(transformData(data.items));
                setRowCount(data.totalCount);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAndSetData();
    }, [paginationModel, sortModel]);

    const handleRowClick = (params) => {
        navigate(`/leads/${params.id}`);
    };

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            rowCount={rowCount}
            paginationMode="server"
            sortingMode="server"
            columnVisibilityModel={{
                id: false,
            }}
            getRowId={(row) => row.id}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[50, 75, 100]}
            onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            filterMode="server"
            checkboxSelection
            disableRowSelectionOnClick
            loading={loading}
            onRowClick={handleRowClick}
            sx={{
                maxHeight: '500px',
                overflow: 'auto',
                minHeight: 200,
                height: '100%', // Fills the parent container
                '& .MuiDataGrid-virtualScroller': {
                    overflow: 'auto', // Ensures scrollbars appear when necessary
                },
            }}
        />
    );
};

export default LeadsGlobalSearch;
